import { create } from 'zustand';
import { ProfileService } from '../profile/ProfileService';

interface ProfileState {
  profile: Record<string, any> | null;
  isClinical: boolean;
  isProfileComplete: boolean;
  hasChecked: boolean;
  loading: boolean;
  error: string | null;
  fetchPromise: Promise<any> | null;
  fetchProfile: (force?: boolean) => Promise<any>;
  clearProfile: () => void;
}

export const useProfileStore = create<ProfileState>((set, get) => ({
  profile: null,
  isClinical: false,
  isProfileComplete: false,
  hasChecked: false,
  loading: false,
  error: null,
  fetchPromise: null,

  fetchProfile: async (force = false) => {
    // Retornar rápido si ya se cargó, no forzamos la actualización y no está cargando actualmente
    if (get().hasChecked && !force && !get().loading) {
      return get().profile;
    }

    if (get().fetchPromise) {
      return get().fetchPromise;
    }

    const promise = (async () => {
      set({ loading: true, error: null });
      try {
        const profile = await ProfileService.getProfile();
        if (profile) {
          const isClinico = await ProfileService.isClinicalProfessional();
          const complete = !!(profile.perfil_dni && profile.perfil_fecha_nacimiento);
          set({
            profile,
            isClinical: isClinico,
            isProfileComplete: complete,
            hasChecked: true,
            loading: false,
          });
          return profile;
        } else {
          set({
            profile: null,
            isClinical: false,
            isProfileComplete: false,
            hasChecked: true,
            loading: false,
          });
          return null;
        }
      } catch (err: any) {
        console.error("[useProfileStore] Error al obtener perfil:", err);
        set({ error: err.message || 'Error', loading: false });
        return null;
      } finally {
        set({ fetchPromise: null });
      }
    })();

    set({ fetchPromise: promise });
    return promise;
  },

  clearProfile: () => set({
    profile: null,
    isClinical: false,
    isProfileComplete: false,
    hasChecked: false,
    loading: false,
    error: null,
  }),
}));
